import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { BasicButton } from "../../../../../../theme/Component/BasicButton";
import { EditorSpareInventoried } from "../../../../../../Factoty&Production/Maintenance/SpareInventoriedType/SpareInventoried/EditorSpareInventoried";
import useDataBean from "../../../../../../../core/services/dataBean/useDataBean";
import { _SpareInventoried } from "../../../../../../../core/services/dataBean/EntityCatalog";

interface addCondition {
    ItemID: number;
    sparedInventorie: any;
    Quantity: number;
}

interface Props {
    jsonProps: string;
    onChange: Function;
}

export const ListRequestItemsMantenance = ({ jsonProps, onChange }: Props) => {
    const { instance, bean, setBean, lista, setLista } = useDataBean(_SpareInventoried);
    const [format, setFortmat] = useState<Partial<addCondition>>({});
    const [quantity, setQuantity] = useState<number>(0);

    useEffect(() => {
        getLista();
    }, [])

    const getLista = () => {
        try {
            if (jsonProps && jsonProps.trim() !== "") {
                const parsed = JSON.parse(jsonProps);
                if (Array.isArray(parsed)) {
                    setLista(parsed);
                } else {
                    toast.error("El formato de jsonProps no es una lista válida.");
                    setLista([]);
                }
            } else {
                setLista([]);
            }
        } catch (error) {
            toast.error("Error al parsear jsonProps.");
            setLista([]);
        }
    };


    const create = () => {
        const iditem = format.ItemID;
        const cantidad = format.Quantity;
        const objeto = format.sparedInventorie;



        if (!iditem) {
            toast.error("seleccione un item valido");
            return;
        } else if (!cantidad) {
            toast.error("digite una cantidad valida");
            return;
        }
        const yaExiste = lista.some(item => item.ItemID === iditem);
        if (yaExiste) {
            toast.error("Este producto ya está en la lista");
            return;
        }

        if (objeto.TotalQuantity < cantidad) {
            toast.error(`Cantidad Actual del objeto en inverario; ${objeto.TotalQuantity}`);
            return;
        }

        instance.updateSpareInventoried({ ...objeto, TotalQuantity: Number(objeto.TotalQuantity - cantidad) }).then(
            (resp: any) => {
                const updatedCode = {
                    ItemID: iditem,
                    Quantity: cantidad,
                    ...objeto
                };
                setLista([...lista, updatedCode]);

                setFortmat({
                    ItemID: null,
                    sparedInventorie: {},
                    Quantity: 0,
                });
            }
        ).catch(err => {
            console.log(err);
            toast.error("No se pudo Actualizar la cantidad del objeto");
        })
    };


    const deleteItem = (index: number) => {

        const objetoAEliminar = lista[index];
        console.log("Objeto a eliminar:", objetoAEliminar);

        instance.updateSpareInventoried(objetoAEliminar).then(
            (resp: any) => {
                const nuevaLista = lista.filter((_, i) => i !== index);
                setLista(nuevaLista);
            }
        ).catch(err => {
            console.log(err);
            toast.error("No se pudo Actualizar la cantidad del objeto");
        })
    };

    useEffect(() => {
        if (onChange) {
            onChange(JSON.stringify(lista))
        }
    }, [lista])

    return (
        <div className="row">
            <div className="col-md-12 mb-3">
                <div className="row">
                    <div className="col-md-5">
                        <label >Repuesto</label>
                        <EditorSpareInventoried idSelector={format.ItemID} label=" " onChange={(e) => { setFortmat({ ...format, sparedInventorie: e, ItemID: e.IDItem }); setQuantity(e.TotalQuantity) }} />
                    </div>

                    <div className="col-md-5">
                        <label >Cantidad</label>
                        <input type="number" className="form-control" value={format.Quantity} onChange={(e) => { setFortmat({ ...format, Quantity: Number(e.target.value) }) }} />
                    </div>

                    <div className="col-md-2 d-flex align-items-end">
                        <BasicButton eventClick={create} icon="ri-file-add-line">Agregar</BasicButton>
                    </div>
                </div>
            </div>

            <div className="col-md-12">
                <table className="table table-bordered table-hover">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Nombre del Producto</th>
                            <th>Cantidad</th>
                        </tr>
                    </thead>
                    <tbody>
                        {lista.map((item, index) => (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{item.IDItemName}</td>
                                <td>{item.Quantity}</td>
                                <td>
                                    <BasicButton
                                        eventClick={() => deleteItem(index)}
                                        icon="ri-delete-bin-line"
                                        children="Eliminar"
                                    />
                                </td>
                            </tr>
                        ))}
                        {lista.length === 0 && (
                            <tr>
                                <td colSpan={6} className="text-center">No hay codigos de Descuento Configurados</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}